/** Defaults `useDrawPath` applies for any option the caller leaves out. */
export const DrawPathDefaults = {
	/** Grey colour attribute for paths drawn without one. */
	attribute: {
		id: 'default',
		name: 'Default',
		type: 'color',
		value: 0x666666,
	},
	/** Only close-path snapping is on. */
	snapOptions: {
		vertices: false,
		vertexScope: 'all',
		close: true,
		ortho: false,
		radius: 20,
	},
	precisionOptions: {
		enabled: false,
	},
	autoPanOptions: {
		enabled: false,
		edgeMargin: 40,
		animationDuration: 500,
		maxPanDistance: 80,
		throttleMs: 150,
	},
} as const;
